// Environment configuration utility
// This centralizes all environment variable access and provides type safety

interface AppConfig {
  api: {
    baseUrl: string;
  };
  googleMaps: {
    apiKey: string;
  };
  app: {
    name: string;
    version: string;
    environment: string;
  };
  images: {
    placeholderUrl: string;
  };
}

// Get environment variable
const getEnvVar = (key: string): string => {
  return (import.meta as any).env?.[key];
};

// Validate required environment variables
const validateRequiredEnvVars = () => {
  const requiredVars = ["VITE_API_BASE_URL", "VITE_GOOGLE_MAPS_API_KEY"];
  const missing = requiredVars.filter(
    (varName) => !(import.meta as any).env?.[varName]
  );

  if (missing.length > 0) {
    console.warn("Missing required environment variables:", missing);
    console.warn(
      "Please check your .env file and ensure all required variables are set."
    );
  }
};

// App configuration object
export const config: AppConfig = {
  api: {
    baseUrl: getEnvVar("VITE_API_BASE_URL"),
  },
  googleMaps: {
    apiKey: getEnvVar("VITE_GOOGLE_MAPS_API_KEY"),
  },
  app: {
    name: getEnvVar("VITE_APP_NAME"),
    version: getEnvVar("VITE_APP_VERSION"),
    environment: getEnvVar("VITE_NODE_ENV"),
  },
  images: {
    placeholderUrl: getEnvVar("VITE_PLACEHOLDER_IMAGE_URL"),
  },
};

// Validate configuration on import
validateRequiredEnvVars();

// Helper functions
export const isDevelopment = () => config.app.environment === "development";
export const isProduction = () => config.app.environment === "production";

// Export individual config sections for convenience
export const { api, googleMaps, app, images } = config;
